// The Floor's shared event bus. Holds two short feeds — the peripheral
// awareness ticker and Coworker's whispers — both populated ONLY from real
// data (driver GPS/shift transitions, real trip status changes, real
// Kaizen offer arrivals, real assignments) wired in RoomProvider.jsx.
// Nothing in here is simulated or fabricated — if the feed is quiet,
// nothing real happened recently. That emptiness is meaningful.

// ─── Room mood by time of day — an ambiance label, not a claim about any
// person, trip, or company. Purely cosmetic.
export function moodForHour(hour) {
  if (hour < 5)  return { key: "night",     label: "quiet · night shift",      activity: 0.15, tempo: 0.4 };
  if (hour < 7)  return { key: "dawn",      label: "waking up · early dialysis", activity: 0.35, tempo: 0.6 };
  if (hour < 10) return { key: "morning",   label: "morning peak",             activity: 0.85, tempo: 1.0 };
  if (hour < 12) return { key: "midmorn",   label: "steady",                   activity: 0.65, tempo: 0.9 };
  if (hour < 14) return { key: "noon",      label: "midday · lunch coverage",  activity: 0.55, tempo: 0.7 };
  if (hour < 17) return { key: "afternoon", label: "return trips building",    activity: 0.75, tempo: 0.9 };
  if (hour < 20) return { key: "evening",   label: "evening handoff",          activity: 0.55, tempo: 0.7 };
  if (hour < 23) return { key: "wind",      label: "winding down",             activity: 0.3,  tempo: 0.5 };
  return           { key: "late",      label: "night · on-call only",          activity: 0.15, tempo: 0.4 };
}

// Live event bus. Mutable, no simulation/tick — every entry is pushed by a
// real signal (see RoomProvider.jsx's effects on liveDrivers/allDrivers,
// and its onTripStateChange/onOfferArrival/assignTrip callbacks).
export class LiveEventBus {
  constructor() {
    this.events = [];    // peripheral awareness feed (last 40)
    this.whispers = [];  // Coworker whispers (last 12)
  }

  addEvent(kind, text, tone = "calm") {
    this.events.unshift({ id: Math.random().toString(36).slice(2), kind, text, tone, at: Date.now() });
    if (this.events.length > 40) this.events.length = 40;
  }

  addWhisper(text, confidence = null, actionable = false, tone = null) {
    this.whispers.unshift({
      id: Math.random().toString(36).slice(2),
      text, confidence, actionable, tone, at: Date.now(),
    });
    if (this.whispers.length > 12) this.whispers.length = 12;
  }
}
